import React, { useState, useEffect } from "react";
import CardHeadeWithActions from "../../components/ui/CardHeadeWithActions";
import { MwButton } from "../../components/ui";
import WarehousesList from "./components/WarehousesList";
import WarehouseForm from "./components/WarehouseForm";
import { IoAddCircleOutline } from "react-icons/io5";
import { useFetch } from "../../hooks";
import WarehouseView from "./components/WarehouseView";
import { useTranslation } from "react-i18next";
import { LuLayoutDashboard } from "react-icons/lu";
import { FaTimes } from "react-icons/fa";

const HomeWarehouses = () => {
  const [t] = useTranslation("global");

  const [mode, setMode] = useState("list"); // 'list', 'add', 'edit'
  const [isAdded, setIsAdded] = useState(false);
  const [reloadList, setReloadList] = useState(false);
  const [selectedWarehouseId, setSelectedWarehouseId] = useState(null);
  const [warehouseFormState, setWarehouseFormState] = useState({
    code: "",
    name_ar: "",
    name_en: "",
    address: "",
    is_active: false,
  });
  const [showForm, setShowForm] = useState(false);
  const {
    data: warehouseData,
    loading: fetchLoading,
    error: fetchError,
  } = useFetch(
    selectedWarehouseId
      ? `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/${selectedWarehouseId}`
      : null,
  );
  useEffect(() => {
    if (isAdded) {
      setReloadList(true);
    }
  }, [isAdded]);

  useEffect(() => {
    if (fetchError) {
      console.error("Error fetching warehouse:", fetchError);
      handleCancel(); // Return to list view if there's an error
    }
  }, [fetchError]);

  useEffect(() => {
    if (warehouseData && mode === "edit") {
      setWarehouseFormState({
        code: warehouseData.code || "",
        name_ar: warehouseData.name_ar || "",
        name_en: warehouseData.name_en || "",
        address: warehouseData.address || "",
        is_active: warehouseData.is_active || false,
      });
    }
  }, [warehouseData]);

  const handleEdit = (warehouseId) => {
    setSelectedWarehouseId(warehouseId);
    setMode("edit");
  };

  const handleView = (warehouseId) => {
    setSelectedWarehouseId(warehouseId);
    setMode("view");
  };

  const handleShowForm = () => {
    setShowForm(true);
  };

  const handleAdd = () => {
    setSelectedWarehouseId(null);
    setWarehouseFormState({
      code: "",
      name_ar: "",
      name_en: "",
      address: "",
      is_active: false,
    });
    setMode("add");
  };

  const handleCancel = () => {
    setMode("list");
    setSelectedWarehouseId(null);
    setWarehouseFormState({
      code: "",
      name_ar: "",
      name_en: "",
      address: "",
      is_active: false,
    });
  };

  return (
    <div >
      <CardHeadeWithActions
        icon={<LuLayoutDashboard size={18} />}
        title={t("requisition.warehouse_management")}
      >
        {mode === "list" && (
          <MwButton
            actionType="button"
            inGroup={true}
            type="saveBtn"
            onClick={handleAdd}
          >
            <IoAddCircleOutline className="w-6 h-6" />

            {t("requisition.add")}
          </MwButton>
        )}

        {(mode === "add" || mode === "edit") && (
          <MwButton
            actionType="button"
            inGroup={true}
            type="saveBtn"
            onClick={handleCancel}
          >
            {t("requisition.warehouse_lists")}
          </MwButton>
        )}

        {mode === "view" && (
          <MwButton
            actionType="button"
            inGroup={true}
            type="saveBtn"
            onClick={handleCancel}
          >
            {t("requisition.warehouse_lists")}
          </MwButton>
        )}
      </CardHeadeWithActions>

      {mode === "list" ? (
        <WarehousesList
          reloadList={reloadList}
          onEdit={handleEdit}
          onView={handleView}
          refreshHandler={() => setReloadList(true)}
        />
      ) : mode === "view" ? (
        <WarehouseView
          warehouse={warehouseData} // Remove ?.data since the data is already structured
          onCancel={handleCancel}
          onEdit={handleEdit} // Change onView to onEdit to match the intended behavior
          onDelete={(id) => {
            // Handle delete logic
            handleCancel();
          }}
        />
      ) : (
        <WarehouseForm
          warehouseFormState={warehouseFormState}
          setWarehouseFormState={setWarehouseFormState}
          mode={mode}
          setIsAdded={setIsAdded}
          onCancel={handleCancel}
          warehouseId={selectedWarehouseId}
        />
      )}
    </div>
  );
};

export default HomeWarehouses;
